import { motion } from "framer-motion";
import { useEnquiry } from "@/components/site/EnquiryProvider";
import { Phone, Mail, MapPin } from "lucide-react";

const details = [
  { icon: Phone, label: "Call / WhatsApp", value: "+91 88008 64175", href: "https://wa.me/918800864175", testid: "contact-phone" },
  { icon: Mail, label: "Email", value: "theartlounge.nirvana@gmail.com", href: "mailto:theartlounge.nirvana@gmail.com", testid: "contact-email" },
  { icon: MapPin, label: "The Studio", value: "#402, C Block, Nirvana Courtyard, Sector 50, Gurugram \u2013 122018", href: "https://maps.google.com/?q=Nirvana+Courtyard+Sector+50+Gurugram", testid: "contact-address" },
];

export default function Contact() {
  const { openEnquiry } = useEnquiry();

  return (
    <section
      id="contact"
      className="relative py-24 md:py-36 bg-sand"
      data-testid="contact-section"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="md:col-span-7">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="font-body text-[11px] tracking-[0.35em] uppercase text-ochre mb-6"
          >
            Acquire &middot; Commission &middot; Visit
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[1] text-ink tracking-tight max-w-2xl"
          >
            Let a painting
            <br />
            <span className="italic text-ochre">find its home.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="mt-8 max-w-lg font-body text-base md:text-lg text-ink-soft leading-relaxed"
          >
            Enquire about an original, commission a bespoke piece, or arrange a visit
            to The Art Lounge Nirvana. Every conversation is answered personally.
          </motion.p>

          <motion.button
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.25 }}
            onClick={() => openEnquiry(null)}
            data-testid="contact-enquire-button"
            data-cursor="Enquire"
            className="group mt-10 inline-flex items-center gap-3 bg-ink px-9 py-5 font-body text-xs tracking-[0.25em] uppercase text-paper transition-colors hover:bg-ochre"
          >
            Start an enquiry
            <span className="transition-transform group-hover:translate-x-1">&rarr;</span>
          </motion.button>
        </div>

        <div className="md:col-span-5 space-y-2">
          {details.map((d, i) => (
            <motion.a
              key={d.label}
              href={d.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={d.testid}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="group flex items-start gap-5 border-t border-ink-soft/25 py-6 hover:border-ochre transition-colors"
              data-cursor="Open"
            >
              <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center border border-ink-soft/30 text-ink-soft group-hover:bg-ochre group-hover:text-paper group-hover:border-ochre transition-colors">
                <d.icon className="h-4 w-4" />
              </span>
              <span>
                <span className="block font-body text-[10px] tracking-[0.25em] uppercase text-ink-soft">
                  {d.label}
                </span>
                <span className="block font-serif text-xl md:text-2xl text-ink leading-snug mt-1">
                  {d.value}
                </span>
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
